// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import snotify from './plugins/snotify'
import store from '@/store/root'
import dict from './dict'
import VueClipboard from 'vue-clipboard2'
import { VueHammer } from 'vue2-hammer'
import IdleVue from 'idle-vue'
import i18n from '@/i18n'

// Register custom form fields
import FieldTwCheckbox from '@/components/modules/form-fields/FieldTwCheckbox.vue'
import FieldStaticText from '@/components/modules/form-fields/FieldStaticText.vue'
Vue.component('fieldTwCheckbox', FieldTwCheckbox)
Vue.component('fieldStaticText', FieldStaticText)

// use plugins
Vue.use(snotify)
Vue.use(VueClipboard)
Vue.use(VueHammer)
Vue.use(IdleVue, {
  store,
  idleTime: 240 * 1000,
  events: ['mousemove', 'keydown', 'mousedown', 'touchstart', 'pageshow']
})

Vue.config.productionTip = false
// deactive for production
Vue.config.devtools = true
Vue.config.performance = true

// quick hack translate filter
Vue.filter('translate', function (msg) {
  return dict[msg]
})

/* eslint-disable no-new */
export const vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
